/**
 * EditorAnnotation interaction modes
 */
export enum MarkupMode {
  Selection = "selection",
  Point = "point",
  Box = "box",
}

/**
 * Transient state during annotation drawing
 */
export interface DrawingState {
  isDrawing: boolean;
  startPoint: { x: number; y: number } | null;
  tempBox: { x: number; y: number; width: number; height: number } | null;
}
